import React from 'react';
import { withRouter } from 'react-router-dom';
import qs from 'qs';

// Components
import SingleFormLayout from '../../_layout/SingleFormLayout/single-form.layout';
import { LoginFormContainer } from '../../../User/LoginForm/login-form.container';
import { ParentLoginNotice } from '../../../User/ParentLoginNotice/parent-login-notice.component';
import { SignedInRedirect } from '../../../_core/SignedInRedirect/signed-in-redirect.component';
import { SessionType } from '../../../../lib/types/session.types';

interface LoginPageProps {
  location: any;
}

const LoginPageContainer: React.FC<LoginPageProps> = ({ location }) => {
  const { token } = qs.parse(location.search, { ignoreQueryPrefix: true });

  const page = (
    <SingleFormLayout maxWidth="600px">
      <LoginFormContainer token={token && String(token)} />
      <ParentLoginNotice />
    </SingleFormLayout>
  );

  return <SignedInRedirect tree={SessionType.STAFF} discardsLink={Boolean(token)}>{page}</SignedInRedirect>;
}

export const LoginPage = withRouter(LoginPageContainer);
